import { render, staticRenderFns } from "./ModalCancelAndFeedback.vue?vue&type=template&id=0995864f&scoped=true"
import script from "./ModalCancelAndFeedback.vue?vue&type=script&lang=js"
export * from "./ModalCancelAndFeedback.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelAndFeedback.vue?vue&type=style&index=0&id=0995864f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995864f",
  null
  
)

export default component.exports